export default __webpack_public_path__ + "static/TrustAlice Illustrations--02-9ac2199a5fc2b4d115c23c07a8721d09.svg";